import moment from "moment";
import { notify } from "src/services/notifications/notify";
import { rotuloMensagem } from "src/services/notifications/labels";

export function formataNumeroCelular(numeroCliente) {
  if(!numeroCliente) return;
  //normalize string and remove all unnecessary characters
  numeroCliente = numeroCliente.replace(/[^\d]/g, "");

  //check if number length equals to 10
  if (numeroCliente.length === 12) {
      //reformat and return phone number
      return numeroCliente.replace(/(\d{2})(\d{2})(\d{4})(\d{4})/, "($2) $3-$4");
  } else if(numeroCliente.length === 13) {
     return numeroCliente.replace(/(\d{2})(\d{2})(\d{1})(\d{4})(\d{4})/, "($2) $3 $4-$5");
  }

  return null;
}

export const soNumeros = (string) => {
  if(!string) return;
  var numbers = string.replace(/[^0-9]/g, '');
  return numbers;
}

export function badgeFuncNumber(numero) {
  if(numero === 0) return null;
  if (numero > 99) {
      return "+99";
  } else {
      return numero.toString();
  }
}


export const formatarParaVerificar = numeroCliente => {
 
  //normalize string and remove all unnecessary characters
  numeroCliente = numeroCliente.replace(/[^\d]/g, "");

  //check if number length equals to 10
  if (numeroCliente.length === 12) {
      //reformat and return phone number
      return numeroCliente.replace(/(\d{2})(\d{2})(\d{4})(\d{4})/, "$1$29$3$4");
  } else if(numeroCliente.length === 13) {
     return numeroCliente.replace(/(\d{2})(\d{2})(\d{1})(\d{4})(\d{4})/, "$1$2$4$5");
  }

  return null;
}


// Os quatro wrappers abaixo eram copias quase identicas do mesmo bloco
// `if granted -> notifica; else if !== denied -> requestPermission(cb)`. Esse
// segundo ramo rodava de dentro de handlers de socket, fora de qualquer gesto do
// usuario: Firefox/Safari recusam o pedido e a notificacao que o disparou era
// perdida. Agora todos delegam para notify(), que nunca pede permissao (isso e
// responsabilidade do banner) e ganha tag, clique e auto-close de graca.
export const notifyMe = (message) => {
  const response = message?.response;
  if (!response) return;
  notify({
    title: response.sender?.formattedName || 'Nova mensagem',
    body: rotuloMensagem(response),
    tag: response.chatId ? `chat:${response.chatId}` : undefined,
  });
}


// A assinatura era (mensagem, remetente) mas usava `remetente` como titulo,
// enquanto todos os call sites chamam notifyMeStaff('Atenção', 'Você tem...').
// O resultado era titulo e corpo trocados na notificacao. Assinatura corrigida
// para bater com os call sites — nenhum deles precisou mudar.
export const notifyMeStaff = (titulo, mensagem) => {
  notify({ title: titulo, body: mensagem, tag: 'chat-interno' });
}

export const getBase64 = (file) => {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    return reader.result;
  };
  reader.onerror = function (error) {
    return null;
  };
}

export function verifyRules(array, rule) {
if (!array) return false;
return array.includes(rule);
}


export function validaMenu(rules, testagem) {
  return rules.some(r=> testagem.indexOf(r) >= 0);
}


export function verifyFeatures(array, rule) {
  if (!array) return false;
  return array.includes(rule);
  }

/** Keys de recurso com controle em 3 níveis (features → plugins → userRules). */
export const FEATURE_KEYS = {
  MARKETING_POSTS: 'marketing.posts',
  MARKETING_ADS: 'marketing.ads',
  SMS: 'marketing.sms',
  WEBCHAT: 'webchat',
  PROPOSALS: 'proposals',
  CHAT_ARCHIVE: 'chatArchive',
  MESSENGER: 'messenger',
  INSTAGRAM_DIRECT: 'instagram',
  TELEGRAM: 'telegram',
  MERCADO_LIVRE: 'mercadoLivre',
};

const PLUGIN_SLUG_ALIASES = {
  [FEATURE_KEYS.INSTAGRAM_DIRECT]: ['instagram', 'instagram.direct'],
  instagram: ['instagram', 'instagram.direct'],
  'instagram.direct': ['instagram', 'instagram.direct'],
  [FEATURE_KEYS.TELEGRAM]: ['telegram'],
  [FEATURE_KEYS.MESSENGER]: ['messenger'],
  [FEATURE_KEYS.WEBCHAT]: ['webchat'],
  // A feature key e camelCase (padrao das keys) mas o slug do plugin no banco e
  // kebab-case (padrao dos slugs, como whatsapp-business) — o alias cobre os dois
  // para nao depender de qual grafia foi cadastrada.
  [FEATURE_KEYS.MERCADO_LIVRE]: ['mercadoLivre', 'mercado-livre', 'mercado_livre'],
  'mercado-livre': ['mercadoLivre', 'mercado-livre', 'mercado_livre'],
  mercado_livre: ['mercadoLivre', 'mercado-livre', 'mercado_livre'],
  'whatsapp-business': ['whatsapp-business', 'whatsapp.business'],
  'whatsapp.business': ['whatsapp-business', 'whatsapp.business'],
  [FEATURE_KEYS.SMS]: ['marketing.sms', 'sms'],
  sms: ['marketing.sms', 'sms'],
  [FEATURE_KEYS.MARKETING_POSTS]: ['marketing.posts', 'marketing.instagram'],
  'marketing.instagram': ['marketing.posts', 'marketing.instagram'],
};

export function pluginSlugAliases(slug) {
  if (!slug) return [];
  return PLUGIN_SLUG_ALIASES[slug] || [slug];
}

export function matchesPluginSlug(installed, slug) {
  if (!slug || installed == null) return false;
  const aliases = pluginSlugAliases(slug);
  const has = (candidate) => {
    if (installed instanceof Set) return installed.has(candidate);
    if (Array.isArray(installed)) return installed.some((item) => String(item) === candidate);
    return false;
  };
  return aliases.some(has);
}

/**
 * Nível 2 (org): recurso instalado em clientes.plugins.
 */
export function hasOrgFeature(cliente, featureKey) {
  if (!featureKey || !cliente) return false;
  return matchesPluginSlug(cliente.plugins, featureKey);
}

/**
 * Localiza entrada em userRules (string legada ou { name, status }).
 */
export function getUserRuleEntry(userRules, featureKey) {
  if (!featureKey || !Array.isArray(userRules)) return null;
  return userRules.find((rule) => {
    if (typeof rule === 'string') return rule === featureKey;
    return rule?.name === featureKey;
  }) ?? null;
}

/**
 * Trava por usuário: { name: "proposals", status: false } esconde o recurso.
 * Sem entrada (ou status true / string legada) → não bloqueia.
 */
export function isUserFeatureDenied(user, featureKey) {
  const entry = getUserRuleEntry(user?.userRules, featureKey);
  if (!entry || typeof entry === 'string') return false;
  return entry.status === false;
}

/**
 * Acesso no painel:
 * 1. Plugin instalado na org (clientes.plugins)
 * 2. Sem trava em userRules com status: false
 */
export function hasFeatureAccess(cliente, user, featureKey) {
  if (!hasOrgFeature(cliente, featureKey)) return false;
  if (isUserFeatureDenied(user, featureKey)) return false;
  return true;
}

export function resultTimes(values) {
  if (!values) return 0;
  const inteiro = Math.floor(values);
 
  let format = `${verificahoras(inteiro)} ${inteiro >= 60 ? "h" : "min"}`
  return format;
}

export function verificahoras(number) {
if (number >= 60) {
  return Math.floor((number / 60))
} else {
  return Math.floor(number);
}
}


export const notifyMeComentario = (titulo, content) => {
  notify({ title: titulo, body: content, tag: 'comentario' });
}


export function validaLabelMenuDatas(value, dataInicial, dataFinal) {
  if(value) {
    if(value === "mes_atual") {
      return "Esse mês";
    } else if(value === "mes_anterior") {
      return "Mês anterior";
    }   else if(value === "ultimos_90_dias") {
      return "Ultimos 3 meses";
    } else if(value === "null") {
      if(dataInicial && dataFinal) {
        let inicio2 = moment(dataInicial).format("DD/MM/YYYY");
        let final2 = moment(dataFinal).format("DD/MM/YYYY");
  
        return `De ${inicio2} a ${final2}`;
  
      }
    }
  } else {
    


  }
      
}


// `chatId` opcional: quando informado, o clique na notificacao abre a conversa.
export const notifyNewMessage = (message, chat, chatId) => {
  if (!message) return;

  const foto_perfil_contato = !message?.sender?.profilePicThumbObj?.eurl ? null : message?.sender?.profilePicThumbObj?.eurl;
  const name = chat && chat.nomeCliente ? chat.nomeCliente : message?.sender?.formattedName ? message?.sender?.formattedName : soNumeros(message.chatId);

  const idParaTag = chatId || chat?._id || message.chatId;

  notify({
    title: name || 'Nova mensagem',
    // Antes so `chat`, `ptt` e `image` montavam notificacao: video, documento,
    // sticker, localizacao e contato tocavam o som e nao mostravam nada.
    body: rotuloMensagem(message),
    icon: foto_perfil_contato || undefined,
    tag: idParaTag ? `chat:${idParaTag}` : undefined,
    chatId: chatId || chat?._id,
  });
}


export function obterNumeroPorClienteId(cliente_id, arr) {
  for (let i = 0; i < arr.length; i++) {
      if (arr[i].cliente_id === cliente_id) {
          return arr[i].nome;
      }
  }
  // Se o cliente_id não for encontrado, você pode retornar um valor padrão ou lançar uma exceção, dependendo dos requisitos do seu aplicativo.
  return null; // Ou outra ação apropriada, como lançar um erro.
}




export function getTransformEventsWebhook(key) {
  const events = {
  "whatsapp.payload_message": "Payload Whatsapp",
  "whatsapp.pesquisa_concluida": "Após Pesquisa",
  "whatsapp.after_resposta_pesquisa": "Após Resposta Pesquisa",
  "wpp_text_client_init": "Whatsapp: Mensagem Recebida",
  "whatsapp.message.status": "Whatsapp: Status da Mensagem",
  "whatsapp_business.message.received": "WhatsApp Business: Mensagem Recebida",
  "whatsapp_business.message.sent": "WhatsApp Business: Mensagem Enviada",
  "whatsapp_business.message.status": "WhatsApp Business: Status da Mensagem"
};

return events[key]
}


export function validarNumeroWhatsapp(numero) {
  // Converte o número para string para facilitar a manipulação
  numero = Math.abs(numero);
  let numeroString = numero.toString();

  // Verifica se os dois primeiros dígitos são "55"
  if (numeroString.startsWith('55')) {
    // Obtém os dígitos da posição 3 e 4
    let digits = parseInt(numeroString.substr(2, 2), 10);
    
      const codigoPais = numeroString.substr(0, 2);
         const ddd = numeroString.substr(2, 2);
        const numero = numeroString.substr(4, 14);

    // Verifica se os dígitos da posição 3 e 4 são maiores que 31
    if (digits >= 31) {
        let numeroF;
        if(numero.length === 8) {
          numeroF = numero
        } else {
          numeroF =  numero.substr(1)
        }
        
      return codigoPais + ddd + numeroF
      
    } else {
        let numeroF;
        if(numero.length === 8) {
          numeroF = 9 + numero
        } else {
          numeroF =  numero
        }
      return codigoPais + ddd + numeroF
    }
  }

  // Retorna o número modificado ou o original, dependendo das condições
  return parseInt(numeroString, 10);
}

export const maskCPF = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export function mascararTel(v) {
  if(!v) return "";  
  v = v.replace(/\D/g, "");
  v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
  v = v.replace(/(\d)(\d{4})$/, "$1-$2");
  return v;
}

export function parseMoedaBR(valor) {
  if (valor == null || valor === '') return 0;
  if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
  const cleaned = String(valor).replace(/[R$\s]/gi, '').trim();
  if (!cleaned) return 0;
  if (cleaned.includes(',')) {
    const [intPart, fracPart = ''] = cleaned.split(',');
    const int = intPart.replace(/\D/g, '');
    const frac = fracPart.replace(/\D/g, '').slice(0, 2);
    const parsed = Number(`${int || '0'}.${frac.padEnd(2, '0')}`);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  const int = cleaned.replace(/\D/g, '');
  return Number(int) || 0;
}

export function maskMoedaBR(valor) {
  if (valor == null || valor === '') return '';
  const text = String(valor);
  const hasComma = text.includes(',');
  const [intRaw, decRaw = ''] = text.replace(/[R$\s]/gi, '').split(',');
  const intDigits = (intRaw || '').replace(/\D/g, '');
  const decDigits = (decRaw || '').replace(/\D/g, '').slice(0, 2);
  if (!intDigits && !hasComma) return '';
  const intFmt = intDigits ? Number(intDigits).toLocaleString('pt-BR') : '0';
  return hasComma ? `${intFmt},${decDigits}` : intFmt;
}

export function formatMoedaBR(valor) {
  const n = parseMoedaBR(valor);
  if (!n) return '';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const maskDate = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1");
};


export const validarCPF = (cpf) => {
  let i;
  let rev;
  let add;
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf == '') return false;
  // Elimina CPFs invalidos conhecidos	
  if (cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999")
    return false;
  // Valida 1o digito	
  add = 0;
  for (i = 0; i < 9; i++)
    add += parseInt(cpf.charAt(i)) * (10 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(9)))
    return false;
  // Valida 2o digito	
  add = 0;
  for (i = 0; i < 10; i++)
    add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(10)))
    return false;
  return true;
}


export function verificarUrlProvider() {
  // Obtém a URL atual
  const urlAtual = window.location.href;

  // Exemplo de verificação simples: verificar se a URL contém uma palavra específica
  if (urlAtual.includes('eva')) {
    return 'iaeva.com.br'
  } else if (urlAtual.includes('lais')) {
    return 'lais.app'
  } else {
    return 'lais.app';
  }

}

export const convertUrls = text => {
  // eslint-disable-next-line no-useless-escape
  const urlRegex =/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
  return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '" target="_blank">' + url + '</a>';
  });
};


export function isLastChild(arr, index) {
  return arr.length === index + 1
}



export const convertStringArrayToNumber = (arr) => {
  return arr.map(item => Number(item));
};

